import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ALMOST_FULL_WIDTH_MOBILE_DIALOG_CLASS, DEFAULT_DIALOG_CLASS } from "@merri/common";
import { VisionboardItem, VisionboardTemplateLane } from "../../models";
import { VisionboardItemCompatibilityService } from "../../services";
import { IVisionboardWorkspaceTemplateLaneComponent } from "../visionboard-workspace-template-lane/visionboard-workspace-template-lane.component";

export interface CompatibleItemSelectionInput {
  parentItem: VisionboardItem;
}

@Component({
    selector: "app-visionboard-compatible-item-selection-dialog",
    templateUrl: "./visionboard-compatible-item-selection-dialog.component.html",
    styleUrls: ["./visionboard-compatible-item-selection-dialog.component.scss"],
    standalone: false
})
export class VisionboardCompatibleItemSelectionDialogComponent implements OnInit {
  header: string;
  childItemTitle: string;
  parentItem: VisionboardItem;
  lane: VisionboardTemplateLane;

  @ViewChild("templateLane", { static: true }) laneComponent: IVisionboardWorkspaceTemplateLaneComponent;

  constructor(
    private _dialog: MatDialogRef<VisionboardCompatibleItemSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public input: CompatibleItemSelectionInput,
    private visionboardItemCompatibilityService: VisionboardItemCompatibilityService,
  ) {
    this.parentItem = input.parentItem;
  }

  ngOnInit() {
    this._dialog.addPanelClass([DEFAULT_DIALOG_CLASS, ALMOST_FULL_WIDTH_MOBILE_DIALOG_CLASS]);

    this.header = this.visionboardItemCompatibilityService.getItemSelectionDialogHeader(this.parentItem);
    this.childItemTitle = this.visionboardItemCompatibilityService.getChildItemTitle(this.parentItem);
    const childCategory = this.visionboardItemCompatibilityService.getChildCategory(this.parentItem);

    const lane = new VisionboardTemplateLane();
    lane.title = childCategory[1];
    lane.numItems = 4;
    lane.items = [null, null, null, null];
    lane.filters["Type"] = this.parentItem.attributeTypeValues;
    lane.categories[childCategory[0]] = [childCategory[1]];

    this.lane = lane;
  }

  onCloseClick() {
    this._dialog.close();
  }

  onPlaceholderClick() {
    this.laneComponent.promptLaneItemSelection();
  }

  hasItems(): boolean {
    return this.lane.items.some(i => i !== null);
  }
}
